import clsx from 'clsx';
import React, { FC } from 'react';
import Girl from 'assets/images/product_girl.svg';
import styles from './../ClientDashboardCard.module.scss';
import { ClientDashboardCardProps } from 'enums/ClientDashboardCardEnums';
import formatNumberWithCommas from 'shared/utils/formatNumberWithComma';

interface ClientDashbaordCardWithEmissionProps {
  product?: boolean;
  goalValueCompany?: number | undefined;
  goalValueAllProducts: number;
  totalcarbonEmissionOfCompany?: number | undefined;
  totalcarbonEmissionOfAllProducts?: number;
  handleOpenModal?: () => void;
}

const ClientDashbaordCardWithEmission: FC<
  ClientDashbaordCardWithEmissionProps
> = ({
  product,
  goalValueAllProducts,
  totalcarbonEmissionOfAllProducts,
  handleOpenModal,
}: ClientDashbaordCardWithEmissionProps) => {
  const goalFinal = goalValueAllProducts;
  const goalEstimate = Number(goalFinal).toFixed(2);
  let percentageDifference: number | undefined;
  if (product && totalcarbonEmissionOfAllProducts !== undefined) {
    const difference = totalcarbonEmissionOfAllProducts - goalFinal;
    percentageDifference = Math.max(
      Number(((difference / goalFinal) * 100).toFixed(0))
    );
  }

  const goalValue =
    percentageDifference !== undefined
      ? `${Math.abs(percentageDifference)}% ${
          percentageDifference > 0 ? 'more' : 'less'
        } than set goal `
      : '';
  return (
    <div
      className={clsx({
        [styles.cardContainerProduct]:
          (totalcarbonEmissionOfAllProducts &&
            totalcarbonEmissionOfAllProducts <= goalFinal) ||
          goalFinal === undefined,
        [styles.cardContainerProductRed]:
          totalcarbonEmissionOfAllProducts &&
          totalcarbonEmissionOfAllProducts > goalFinal,
      })}>
      <div className={styles.leftContainerProduct}>
        <h2>{ClientDashboardCardProps.HEADING}</h2>
        <div className={styles.leftContainerRowTwo}>
          <h1 className={styles.cardHeading}>
            {formatNumberWithCommas(totalcarbonEmissionOfAllProducts)}{' '}
            <span>
              {ClientDashboardCardProps.CO}
              <sub>{ClientDashboardCardProps.SUBSCRIPT}</sub>
              {ClientDashboardCardProps.POST_SUBSCRIPT}
            </span>
          </h1>
          {goalFinal !== undefined ? (
            <p onClick={handleOpenModal}>
              {goalValue}
              <span className={styles.goalValue}>
                {formatNumberWithCommas(goalEstimate)}{' '}
                {ClientDashboardCardProps.KG_CARBON_EMISSION}
              </span>
              <span className={styles.goalEdit}>
                {ClientDashboardCardProps.EDIT_GOAL_LABEL}
              </span>
            </p>
          ) : (
            <p onClick={handleOpenModal}>
              <span className={styles.goalEdit}>
                {ClientDashboardCardProps.SET_GOAL}
              </span>
            </p>
          )}
        </div>
      </div>
      <div className={styles.rightContainerProduct}>
        {totalcarbonEmissionOfAllProducts &&
          totalcarbonEmissionOfAllProducts <= goalFinal && (
            <img
              src={Girl}
              alt={ClientDashboardCardProps.GIRL_ILLUSTRATION_ALT}
              className={styles.illustration}
            />
          )}
      </div>
    </div>
  );
};

export default ClientDashbaordCardWithEmission;
